import type { Locale } from 'date-fns';
import { enGB, enUS, it, es, fr, de, pl, pt } from 'date-fns/locale';

const locales = { enGB, enUS, it, es, fr, de, pl, pt };

export const getCurrentLocaleObj = (): Locale => {
  return locales[window.navigator.language.replace('-', '')] ?? enGB;
};
